import { Grid } from "@material-ui/core";
import { InputTextArea, MasterButton, Modal } from "App/Component/ui";
import {
  DEFAULT_SHOW_BUTTON_SUBMIT,
  DISABLED_BUTTON_SUBMIT,
  instance2,
} from "App/constants";
import {
  defaultToastError,
  defaultToastSuccess,
  today,
  toUTCFormat,
} from "App/utils/helpers";
import React, { useState } from "react";
import { LIST_URL_REGISTRASI } from "utils/registrations";

function ModalCancel({
  setShowModal,
  setRegistrationId,
  registrationId,
  setNewData,
  url = LIST_URL_REGISTRASI.kunjungan_rawat_jalan.cancel_rawat_jalan,
  defaultAlasan = "",
}) {
  const [disabled, setDisabled] = useState(DEFAULT_SHOW_BUTTON_SUBMIT);
  const [alasan, setAlasan] = useState(defaultAlasan);
  const handleSubmit = async (e) => {
    e.preventDefault();
    setDisabled(DISABLED_BUTTON_SUBMIT);
    if (registrationId === "") {
      defaultToastError("Pilih registrasi terlebih dahulu");
    }
    try {
      await instance2.post(
        url,
        {
          whycancel: alasan,
        },
        {
          headers: {
            registration_id: registrationId,
          },
        }
      );
      if (
        url === LIST_URL_REGISTRASI.kunjungan_rawat_jalan.cancel_rawat_jalan
      ) {
        await updateJKN();
      }
      defaultToastSuccess("Berhasil Batal Kunjungan");
      setNewData();
      setRegistrationId("");
      setShowModal(false);
      setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT);
    } catch (error) {
      setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT);
      defaultToastError(error?.response?.data?.message);
    }
  };

  const updateJKN = async () => {
    try {
      await instance2.post(
        "/registration/antrianjkn/update-waktu-antrian-emr",
        {
          kode_booking: registrationId,
          task_id: 99,
          tanggal: toUTCFormat(today()),
        }
      );
      return {
        state: true,
        error: "success",
      };
    } catch (error) {
      return {
        state: false,
        error: "Gagal Update JKN",
      };
    }
  };
  return (
    <Modal title={`Batal Kunjungan`} show={setShowModal}>
      <form action='POST' onSubmit={(e) => handleSubmit(e)}>
        <Grid item sm={12}>
          <InputTextArea
            label={"ALASAN"}
            placeholder={"Alasan"}
            name='alasan'
            value={alasan}
            onChange={(e) => {
              setAlasan(e.target.value);
            }}
            id='alasan'
            rows={"3"}
          />
        </Grid>
        <Grid
          container
          direction='row'
          justifyContent='flex-end'
          alignItems='center'>
          <MasterButton
            className={"mt-1"}
            type='submit'
            color={disabled.color}
            name={disabled.label}
            size='md'
          />
        </Grid>
      </form>
    </Modal>
  );
}

export default ModalCancel;
